import {Component, EventEmitter, Input, Output, signal} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpStatusCode} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {SalesWorkflowSteps, toOptionArray, SalesWorkflow} from "../../../../../enums";
import {environment} from "projects/store/src/environments/environment";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {UtilService, CustomMessageService, ResponseHttpError, ResponseHttpSuccess} from "library";
import {MacroFlowService} from 'projects/store/src/app/services/api/v1/macro-flow.service';

enum AccountType {
  'cuenta-corriente'= 'Cuenta Corriente',
  'cuenta-ahorro'= 'Cuenta Ahorro'
}

@Component({
  selector: 'app-banking-transfer-v3',
  templateUrl: './banking-transfer-v3.component.html',
  styles: [
  ]
})
export class BankingTransferComponentV3 {
  formBankTransfer: FormGroup;
  id: string;
  flowCode: string;
  submitted: boolean = false;
  loading: boolean = false;
  country = environment.global.country;


  @Input( {required: true} ) visibleBankTransferModal!: boolean
  @Input({ required: true }) request!: any;


  @Output() onClose = new EventEmitter<boolean>();
  @Output() gotoStepEvent = new EventEmitter<{ flowCode: string; stepCode: string }>();

  constructor( private route: ActivatedRoute,
               private utilService: UtilService,
               private requestService: RequestService,
               private customMessageService: CustomMessageService,
               private macroFlowService: MacroFlowService) {
    this.formBankTransfer = new FormGroup({
      bank_name: new FormControl(null, [Validators.required]),
      type: new FormControl(null, [Validators.required]),
      number: new FormControl(null, [Validators.required])
    });

    this.id = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code'];
  }

  /**
   * Determina si el flujo actual es Krdya (V3)
   */
  get isFlowKrdya(): boolean {
    return this.flowCode === SalesWorkflow['app-krdya-kredicash'];
  }


  onBankTransfer() {
    this.submitted = true;
    if(this.formBankTransfer.invalid) {
      return;
    }

    this.loading = this.utilService.enablePageLoading();
    this.requestService.saveBankAccountPaymentInformation(this.id, this.formBankTransfer.value).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Created) {
          // En el flujo app-krdya-kredicash, mantenerse en el mismo flujo
          const targetFlow = this.isFlowKrdya
            ? SalesWorkflow['app-krdya-kredicash']
            : this.macroFlowService.getKredicashClienteFlow();
          this.onGotoStep(targetFlow, SalesWorkflowSteps['final-message-bank-transfer']);
        }else{
          this.customMessageService.responseError();
        }
        this.loading = this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.comunicationError();
        this.loading = this.utilService.disablePageLoading();
      }
    });
  }


  get fBankTransfer() {
    return this.formBankTransfer.controls;
  }

  onGotoStep(flowCode: string, stepCode: string) {
    this.gotoStepEvent.emit({ flowCode, stepCode });
  }

  closeModal(){
    this.onClose.emit( false);
  }


  protected readonly AccountType = toOptionArray(AccountType);


}
